import Button from "@atlaskit/button/standard-button";
import FooterLogo from "../assets/icons/logo-footer.png";

export const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-item">
        <a
          href="https://twinit.atlassian.net/wiki/spaces/IB/overview?homepageId=596377785"
          target="_blank"
          rel="noreferrer"
        >
          <Button appearance="subtle-link">Documentation</Button>
        </a>
        <a href="https://twinit.ge/terms/eula" target="_blank" rel="noreferrer">
          <Button appearance="subtle-link">EULA</Button>
        </a>
      </div>
      <div className="footer-item">
        <a
          href="https://marketplace.atlassian.com/vendors/1220298/"
          target="_blank"
          rel="noreferrer"
        >
          <Button appearance="subtle-link">
            Twinit’s presence on Atlassian Marketplace
          </Button>
        </a>
        <div className="separator" />
        <a href="https://twinit.ge" target="_blank" rel="noreferrer">
          <Button appearance="subtle-link">twinit.ge</Button>
        </a>
        <img style={{ marginTop: "2px" }} src={FooterLogo} alt="TwinIT" />
      </div>
    </div>
  );
};
